import { GetCountries,GetState,GetCity, } from 'react-country-state-city';

export const getCountryName = async(countryId=101) => {
  const countries = await GetCountries() || [];
  const country = countries.find((country) => country.id === countryId);
  return country?.name || "";
};

export const getStateName = async(countryId=101, stateId) => {
  const states = await GetState(countryId) || [];
  const state = states.find((state) => state.id === stateId);
  return state?.name || "";
};

export const getCityName = async(countryId=101, stateId, cityId) => {
  const cities = await GetCity(countryId,stateId) || [];
  const city = cities.find((city) => city.id === cityId);
  return city?.name || "";
};

const formatAddressDetails = async (address) => {
    try {
      if (!address) {
        return {
          city: "",
          state: "",
          country: "",
        };
      }
  
      // Fetch address components (assuming these are async functions)
      const city = await getCityName(address.ctr, address.st, address.ct);
      const state = await getStateName(address.ctr, address.st);
      const country = await getCountryName(address.ctr, address.st);

      return {
       city,
       state,
       country
      };
    } catch (error) {
      return {
        city: "",
        state: "",
        country: "",
      };
    }
  };
  
  export default formatAddressDetails;
  